import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as a11y from '@shopify/theme-a11y';
Avatar.theme = Avatar.theme || {};

Avatar.theme.A11yDropdown = function A11yDropdownFn() {
  var classes = {
    active: 'active'
  };
  var key = {
    enter: 13,
    space: 32,
    esc: 27,
    tab: 9
  };

  function A11yDropdown(trigger, dropdown) {
    this.trigger = trigger;
    this.triggerParent = trigger.parentElement;
    this.dropdown = dropdown;
    this.dropdownFirstLink = dropdown.querySelector('a');

    this._setupListeners();
  }

  A11yDropdown.prototype = _objectSpread(_objectSpread({}, A11yDropdown.prototype), {}, {
    _setupListeners: function _setupListeners() {
      this.eventHandlers = this._setupEventHandlers();
      this.trigger.addEventListener('keydown', this.eventHandlers.handleTriggerKey);
      this.dropdown.addEventListener('keydown', this.eventHandlers.handleDropdownEsc);
      this.dropdown.addEventListener('focusout', this.eventHandlers.handleDropdownFocusOut);
    },
    _setupEventHandlers: function _setupEventHandlers() {
      return {
        handleTriggerKey: this._handleTriggerKey.bind(this),
        handleDropdownEsc: this._handleDropdownEsc.bind(this),
        handleDropdownFocusOut: this._handleDropdownFocusOut.bind(this)
      };
    },
    _handleTriggerKey: function _handleTriggerKey(evt) {
      var keyCode = evt.keyCode;

      if (keyCode === key.enter || keyCode === key.space) {
        evt.preventDefault();
        this.triggerParent.classList.add(classes.active);
        this.trigger.setAttribute('aria-expanded', true);
        this.dropdownFirstLink.focus();
      }
    },
    _handleDropdownEsc: function _handleDropdownEsc(evt) {
      var keyCode = evt.keyCode;
      if (keyCode === key.tab || keyCode === key.enter || keyCode === key.space) return;

      if (keyCode === key.esc) {
        this.triggerParent.classList.remove(classes.active);
        this.trigger.setAttribute('aria-expanded', false);
        a11y.removeTrapFocus();
        this.trigger.focus();
      }
    },
    _handleDropdownFocusOut: function _handleDropdownFocusOut(evt) {
      var childInFocus = evt.currentTarget.contains(evt.relatedTarget);
      var isVisible = this.triggerParent.classList.contains(classes.active);

      if (isVisible && !childInFocus) {
        this.triggerParent.classList.remove(classes.active);
        this.trigger.setAttribute('aria-expanded', false);
      }
    },
    destroy: function destroy() {
      this.trigger.removeEventListener('keydown', this.eventHandlers.handleTriggerKey);
      this.dropdown.removeEventListener('keydown', this.eventHandlers.handleDropdownEsc);
      this.dropdown.removeEventListener('focusout', this.eventHandlers.handleDropdownFocusOut);
    }
  });
  return A11yDropdown;
}();